import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import Position from './Position';
/** @type any */
const Relative = forwardRef((_a, ref) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (_jsx(Position, Object.assign({ position: "relative", ref: ref }, props, { children: children })));
});
export default Relative;
